import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ItemsListRowItemBaseLink } from '../list-row-item-base-link';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'fi-items-list-row-item-a',
    templateUrl: './a.component.html',
    styleUrls: ['./a.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ItemsListRowItemAComponent extends ItemsListRowItemBaseLink {
    ngOnInit(): void {
        super.ngOnInit();
        this.ngModel.favoriteChanged$.pipe(takeUntil(this.ngOnDestroy$)).subscribe(() => {
            this.cdr.markForCheck();
        });
    }

    IsShowFavorite() {
        return this.ngModel.ShowFavoriteIcon;
    }

    onClick($event: MouseEvent) {
        if (this.head.Properties.ExtraProperties.onClick)
            this.head.Properties.ExtraProperties.onClick($event, this.data, this.parentData);
    }
}
